import React, { useEffect, useState, useRef } from 'react';
import Input from '../../components/UI/Input/index';
import Modal from '../../components/UI/Modal';
import { useSelector, useDispatch } from 'react-redux';
import { addProduct, updateProductById } from '../../actions';
import { Row, Col, Form } from 'react-bootstrap';
import { createCategoryList } from '../ComponentContainer/createCategoryList';
import BRenderAddPictures from '../../components/Button/BRenderAddPictures';
import { Button } from '@material-ui/core';

const getPriceCalc = (categories, categoryId) => {
    if (!categoryId || !categories) return null;
    let result = 'piece';
    const findCalc = (cats) => {
        for (let cat of cats) {
            if (cat._id === categoryId || cat.value === categoryId) {
                if (cat.priceCalc) {
                    result = cat.priceCalc;
                }
                return true;
            }
            if (cat.children && cat.children.length > 0) {
                if (findCalc(cat.children)) return true;
            }
        }
        return false;
    };
    findCalc(categories);
    return result;
};

export const AddProductModal = ({
    slug,
    show,
    handleClose,
    currentId,
    productForm,
    setProductForm,
    setProductPictures,
    productPictures,
}) => {
    const category = useSelector((state) => state.category);
    const product = useSelector((state) => currentId ? state.product.products.find((m) => m._id === currentId) : null);

    const [materialArray, setMaterialArray] = useState([]);
    const [errorText, setErrorText] = useState(true);
    const [visibleAllInput, setVisibleAllInput] = useState(false);
    const [selectedModelFile, setSelectedModelFile] = useState(null);
    const [selectedMTLFile, setSelectedMTLFile] = useState(null);
    const [selectedTextureFiles, setSelectedTextureFiles] = useState([]);

    const dispatch = useDispatch();
    const initRef = useRef(false);

    useEffect(() => {
        if (
            productForm.name === "" ||
            productForm.quantity === "" ||
            productForm.categoryId === "" ||
            productForm.visibleProduct === "" ||
            productForm.visibleWatermark === "" ||
            productForm.addWhiteBackground === "" ||
            productPictures.length === 0
        ) {
            setErrorText(true);
        } else {
            setErrorText(false);
        }
    }, [productForm, productPictures]);

    useEffect(() => {
        if (!show) {
            initRef.current = false;
            setSelectedModelFile(null);
            setSelectedMTLFile(null);
            setSelectedTextureFiles([]);
            return;
        }

        if (product && currentId && !initRef.current) {
            setProductForm({
                ...product,
                categoryId: product?.category?._id || product?.categoryId || product?.category || "",
                pricePerMeter: product.pricePerMeter || "",
                visibility: product.visibility || "office",
                article: product.article || "",
            });
            initRef.current = true;
        }
    }, [show, currentId, product, setProductForm]);

    const handleModelFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedModelFile(file);
        }
    };

    const handleMTLFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedMTLFile(file);
        }
    };

    const handleTextureFilesChange = (e) => {
        const files = Array.from(e.target.files);
        if (files.length > 0) {
            setSelectedTextureFiles(files);
        }
    };

    const submitProductForm = () => {
        if (currentId) {
            const payload = { ...productForm };

            delete payload.modelFile;
            delete payload.mtlFile;
            delete payload.textures;
            delete payload.article;

            dispatch(updateProductById(currentId, payload, slug));
            handleClose();
        } else {
            const form = new FormData();

            form.append("name", productForm.name);
            form.append("visibleProduct", productForm.visibleProduct);
            form.append("addWhiteBackground", productForm.addWhiteBackground);
            form.append("visibleWatermark", productForm.visibleWatermark);
            form.append("height", productForm.height || "");
            form.append("width", productForm.width || "");
            form.append("length", productForm.length || "");
            form.append("nameMaterial", productForm.nameMaterial || "");
            form.append("numberMaterialName", productForm.numberMaterialName || "");
            form.append("categoryOnlyLatterName", productForm.categoryOnlyLatterName || "");
            form.append("quantity", productForm.quantity);
            form.append("price", productForm.price || "");
            form.append("pricePerMeter", productForm.pricePerMeter || "");
            form.append("description", productForm.description || "");
            form.append("descriptionNew", productForm.descriptionNew || "");
            form.append("category", productForm.categoryId);
            form.append("size", productForm.size || "");
            form.append("categoryName", productForm.categoryName || "");
            form.append("categorySlug", productForm.categorySlug || "");
            form.append("weight", productForm.weight || "");
            form.append("visibility", productForm.visibility || "office");
            form.append("visibilityPrice", productForm.visibilityPrice || "private");
            form.append("fullName", productForm.fullName || "");

            for (let i = 0; i < productPictures.length; i++) {
                form.append("productPictures", productPictures[i]);
            }

            if (selectedModelFile) {
                form.append("modelFile", selectedModelFile);
            }

            if (selectedMTLFile) {
                form.append("mtlFile", selectedMTLFile);
            }

            if (selectedTextureFiles.length > 0) {
                selectedTextureFiles.forEach(file => form.append("textures", file));
            }

            for (let i = 0; i < materialArray.length; i++) {
                form.append("materialArray", materialArray[i]);
            }

            dispatch(addProduct(form, slug)).then(() => handleClose());
        }
    };

    const categoryList = createCategoryList(category.categories);
    const selectedCategoryPriceCalc = getPriceCalc(category.categories, productForm.categoryId);

    return (
        <Modal
            disabledSubmit={currentId ? false : errorText}
            show={show}
            currentId={currentId}
            handleClose={handleClose}
            modalTitle={!currentId ? "Добавить новый продукт" : `Изменить текст в товаре - ${product?.fullName}`}
            onSubmit={submitProductForm}
        >
            {currentId ? (
                <Row>
                    <Col md="6">
                        <Input
                            label="Артикул"
                            name="article"
                            value={productForm.article || ""}
                            placeholder="Артикул"
                            readOnly
                        />
                    </Col>
                </Row>
            ) : null}

            <Form.Group>
                <Form.Label>Загрузить 3D-модель (OBJ)</Form.Label>
                <Form.Control
                    type="file"
                    name="modelFile"
                    accept=".obj,.stl,.glb,.fbx"
                    onChange={handleModelFileChange}
                />
            </Form.Group>

            <Form.Group>
                <Form.Label>Загрузить MTL-файл (опционально)</Form.Label>
                <Form.Control
                    type="file"
                    name="mtlFile"
                    accept=".mtl"
                    onChange={handleMTLFileChange}
                />
            </Form.Group>

            <Form.Group>
                <Form.Label>Загрузить текстуры (PNG/JPG, опционально)</Form.Label>
                <Form.Control
                    type="file"
                    name="textures"
                    accept=".jpg,.jpeg,.png"
                    multiple
                    onChange={handleTextureFilesChange}
                />
            </Form.Group>

            <Row>
                <Col md="6">
                    {!productForm.categoryId ? (
                        <div style={{ paddingBottom: '15px', color: '#888', fontStyle: 'italic', fontSize: '13px' }}>
                            * Инпут для ввода цены будет показан после выбора категории
                        </div>
                    ) : selectedCategoryPriceCalc === 'linearMeter' ? (
                        <Input
                            label="Цена за погонный метр"
                            name="pricePerMeter"
                            value={productForm.pricePerMeter || ""}
                            placeholder="Цена за метр"
                            onChange={(e) => setProductForm({ ...productForm, pricePerMeter: e.target.value })}
                        />
                    ) : (
                        <Input
                            label="Цена за штуку"
                            name="price"
                            value={productForm.price || ""}
                            placeholder="Цена за штуку"
                            onChange={(e) => setProductForm({ ...productForm, price: e.target.value })}
                        />
                    )}
                </Col>
            </Row>

            {visibleAllInput && (
                <Row>
                    <Col md="8">
                        <Input
                            visibleInput={visibleAllInput}
                            label="Полное имя"
                            name="fullName"
                            value={productForm.fullName || ""}
                            placeholder="Введите полное имя"
                            onChange={(e) => setProductForm({ ...productForm, fullName: e.target.value })}
                        />
                    </Col>
                </Row>
            )}

            {visibleAllInput && (
                <Row>
                    <Col md="4">
                        <Input
                            label="Сгенерированное имя по категории"
                            name="categoryOnlyLatterName"
                            value={productForm.categoryOnlyLatterName || ""}
                            placeholder="Часть имени"
                            onChange={(e) => setProductForm({ ...productForm, categoryOnlyLatterName: e.target.value })}
                        />
                    </Col>
                </Row>
            )}

            {visibleAllInput && (
                <Row>
                    <Col md="4">
                        <Input
                            label="Высота (в мм.)"
                            name="height"
                            value={productForm.height || ""}
                            placeholder="Высота"
                            onChange={(e) => setProductForm({ ...productForm, height: e.target.value })}
                        />
                    </Col>
                    <Col md="4">
                        <Input
                            label="Ширина (в мм.)"
                            name="width"
                            value={productForm.width || ""}
                            placeholder="Ширина"
                            onChange={(e) => setProductForm({ ...productForm, width: e.target.value })}
                        />
                    </Col>
                    <Col md="4">
                        <Input
                            label="Длина (в мм.)"
                            name="length"
                            value={productForm.length || ""}
                            placeholder="Длина"
                            onChange={(e) => setProductForm({ ...productForm, length: e.target.value })}
                        />
                    </Col>
                </Row>
            )}

            <Row>
                <Col md="8">
                    <Input
                        showError
                        label="Название"
                        name="name"
                        value={productForm.name || ""}
                        placeholder="Название"
                        onChange={(e) => setProductForm({ ...productForm, name: e.target.value })}
                    />
                </Col>
                <Col md="4">
                    <Input
                        showError
                        label="Количество"
                        name="quantity"
                        value={productForm.quantity || ""}
                        placeholder="Количество"
                        onChange={(e) => setProductForm({ ...productForm, quantity: e.target.value })}
                    />
                </Col>
            </Row>

            {visibleAllInput && (
                <Row>
                    <Col md="6">
                        <Input
                            label="Имя по материалам"
                            name="nameMaterial"
                            value={productForm.nameMaterial || ""}
                            placeholder="ДМ, ДБ и тд"
                            onChange={(e) => setProductForm({ ...productForm, nameMaterial: e.target.value })}
                        />
                    </Col>
                    <Col md="6">
                        <Input
                            label="Номер товара по категориям"
                            name="numberMaterialName"
                            value={productForm.numberMaterialName || ""}
                            placeholder="Номер"
                            onChange={(e) => setProductForm({ ...productForm, numberMaterialName: e.target.value })}
                        />
                    </Col>
                </Row>
            )}

            {visibleAllInput && (
                <Row>
                    <Col md="8">
                        <Input
                            label="В какой категории находится"
                            name="categoryName"
                            value={productForm.categoryName || ""}
                            placeholder="Категория"
                            onChange={(e) => setProductForm({ ...productForm, categoryName: e.target.value })}
                        />
                    </Col>
                </Row>
            )}

            <Row>
                <Col md="8">
                    <Input
                        showError
                        type="select"
                        label="Режим доступа к товару:"
                        name="visibility"
                        value={productForm.visibility || "office"}
                        placeholder="Выберите режим"
                        onChange={(e) => setProductForm({ ...productForm, visibility: e.target.value })}
                        options={[
                            { value: "public", name: "Public — публичный каталог" },
                            { value: "office", name: "Office — каталог офисов" },
                            { value: "session", name: "Session — только защищённые 3D-сессии" },
                            { value: "private", name: "Private — только глобальная админка" },
                        ]}
                    />
                    <small className="productVisibilityHint">
                        Session не попадает в общий каталог, но может загружаться по разрешённой ссылке конкретной 3D-сцены.
                    </small>
                </Col>
            </Row>

            <Row>
                <Col md="8">
                    <Input
                        showError
                        type="select"
                        label="Укажите видимость товара:"
                        name="visibleProduct"
                        value={String(productForm.visibleProduct)}
                        placeholder="Ничего"
                        onChange={(e) => setProductForm({ ...productForm, visibleProduct: e.target.value === "true" })}
                        options={[
                            { value: "true", name: "Публичный" },
                            { value: "false", name: "Только админ" },
                        ]}
                    />
                </Col>
            </Row>

            <Row>
                <Col md="6">
                    <Input
                        showError
                        type="select"
                        label="Укажите видимость цены:"
                        name="visibilityPrice"
                        value={productForm.visibilityPrice || "private"}
                        placeholder="Ничего"
                        onChange={(e) => setProductForm({ ...productForm, visibilityPrice: e.target.value })}
                        options={[
                            { value: "private", name: "Никому" },
                            { value: "public", name: "Публичный" },
                            { value: "admin", name: "Только админ" },
                        ]}
                    />
                </Col>
            </Row>

            {visibleAllInput && (
                <Input
                    label="Ссылка для перехода"
                    name="categorySlug"
                    value={productForm.categorySlug || ""}
                    placeholder="Ссылка"
                    onChange={(e) => setProductForm({ ...productForm, categorySlug: e.target.value })}
                />
            )}

            <textarea
                style={{ width: "100%", minHeight: "100px" }}
                name="description"
                value={productForm.description || ""}
                placeholder="Подробное описание"
                onChange={(e) => setProductForm((prev) => ({ ...prev, description: e.target.value }))}
            />

            {visibleAllInput && (
                <>
                    <textarea
                        style={{ width: "100%", minHeight: "200px" }}
                        name="descriptionNew"
                        value={productForm.descriptionNew || ""}
                        placeholder="Видимое подробное описание"
                        onChange={(e) => setProductForm((prev) => ({ ...prev, descriptionNew: e.target.value }))}
                    />

                    <Input
                        label="Размеры заготовки"
                        name="size"
                        value={productForm.size || ""}
                        placeholder="Введите размеры"
                        onChange={(e) => setProductForm({ ...productForm, size: e.target.value })}
                    />
                    <Input
                        label="Вес готового изделия"
                        name="weight"
                        value={productForm.weight || ""}
                        placeholder="Вес"
                        onChange={(e) => setProductForm({ ...productForm, weight: e.target.value })}
                    />
                </>
            )}

            {!currentId && (
                <Row>
                    <Col md="8">
                        <Input
                            showError
                            type="select"
                            label="Укажите категорию:"
                            name="categoryId"
                            value={productForm.categoryId || ""}
                            placeholder="Выбрать категорию"
                            onChange={(e) => setProductForm({ ...productForm, categoryId: e.target.value })}
                            options={categoryList}
                        />
                    </Col>
                </Row>
            )}

            {!currentId && (
                <>
                    <BRenderAddPictures
                        setPictures={setProductPictures}
                        pictures={productPictures}
                    />

                    <Row>
                        <Col md="8">
                            <Input
                                showError
                                type="select"
                                label="Водный знак:"
                                name="visibleWatermark"
                                value={productForm.visibleWatermark || ""}
                                placeholder="Выбрать"
                                onChange={(e) => setProductForm({ ...productForm, visibleWatermark: e.target.value })}
                                options={[
                                    { value: "visible", name: "Наложить" },
                                    { value: "hide", name: "Без знака" },
                                ]}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col md="8">
                            <Input
                                showError
                                type="select"
                                label="Добавить белый фон:"
                                name="addWhiteBackground"
                                value={productForm.addWhiteBackground || ""}
                                placeholder="Выбрать"
                                onChange={(e) => setProductForm({ ...productForm, addWhiteBackground: e.target.value })}
                                options={[
                                    { value: "visible", name: "Добавить фон" },
                                    { value: "hide", name: "Без фона" },
                                ]}
                            />
                        </Col>
                    </Row>
                </>
            )}

            <Button
                variant="contained"
                onClick={() => setVisibleAllInput(!visibleAllInput)}
            >
                {!visibleAllInput ? "Все параметры" : "Только основные"}
            </Button>
        </Modal>
    );
};
